<template>
  <div style="text-align: center; padding: 120px">
    <h1>饕餮管理系统</h1>
  </div>
</template>

<script>
export default {
name: "CountPage"
}
</script>

<style scoped>

</style>